// confirmation controller main function
var ConfirmationController = function ($scope, $log, $q, customerModelService, previousState, $state, SettingsConstants, backToMain, $rootScope) {
    //init
    //
    //@description
    //Entry point into controller cient logic
    function init() {
        //fetch required data that stores in customer model service
        var currentVehicle = customerModelService.getCurrentVehicle(),
            currentCustomer = customerModelService.getCustomer(),
            currentScheduledTime = customerModelService.getCurrentScheduledTime(),
            currentServiceAdviser = customerModelService.getCurrentAdviser(),
            currentSelectedServicesAmount = customerModelService.getSelectedServicesAmount();

        $scope.appointment = customerModelService.getCurrentAppointment();
        $scope.totalAmount = $rootScope.total;

        //get view values for current vehicle
        if (currentVehicle) {
            $scope.currentVehicle = currentVehicle;
            $scope.vehicleModel = currentVehicle.getModelRepresentation();
            $scope.vehicleSpecification = currentVehicle.getSpecification();
        }

        //get customer information
        if (currentCustomer) {
            $scope.customerFullName = currentCustomer.getFullName();
        }

        //get data related to view values of scheduled date
        if (currentScheduledTime) {
            $scope.scheduledDate = moment.parseZone(currentScheduledTime.time, moment.ISO_8601).format('LL');
            $scope.scheduledTime = moment.parseZone(currentScheduledTime.time, moment.ISO_8601).format('LT');
        }

        //get data related to current service adviser
        if (currentServiceAdviser) {
            $scope.serviceAdviserPhoto = currentServiceAdviser.photoUrl;
            $scope.serviceAdviserName = currentServiceAdviser.name;
            $scope.serviceAdviserPhone = currentServiceAdviser.phone;
        }
        
        $scope.currentSelectedServicesAmount = currentSelectedServicesAmount;
        $scope.transportationOption = customerModelService.getCurrentTransportationOption();
        $scope.pickupAddress = customerModelService.getTransportationPickupAddress();
        $scope.deliveryAddress = customerModelService.getTransportationDeliveryAddress();
        $scope.department = customerModelService.getCurrentDepartment();
        $rootScope.isSchedule = false;
    }

    //gottoMyMain
    //
    //@description
    //leads user to the welcome page
    $scope.gotoMyMain = function () {
        backToMain.backToMain();
        //$state.go(SettingsConstants.APP_DEFAULT_STATE);
    };
    // go to previous state
    $scope.goBack = function () {
        $state.go(previousState.name, previousState.params);
    };


    $scope.iCalSync = function () {
        var iCalLink = _.get(_.find($scope.appointment.links, ['rel', 'http://api.dealer-fx.com/docs/rels/appointment-calendar+ics']), 'href');
        if (iCalLink) {
            window.open(iCalLink, '_self', 'download');
        } else {
            $log.error('Something went wrong due to get appointment data');
        }
    };

    $scope.showMap = function() {
        return window.appSettings.googleMapApiKey.replace(' ', '').length;
    };
    //run the controller
    init();
};
// confirmation controller injections
ConfirmationController.$inject = ['$scope', '$log', '$q', 'customerModelService', 'previousState', '$state', 'SettingsConstants', 'backToMain', '$rootScope'];
// confirmation controller implelmentation
module.exports = ConfirmationController;
